import type { Pin } from "models";

// TODO backend need to update the Pin/Snooze models with proper attachments array instead of string arrays
export const pinsAttachments = (log?: Pin[]) =>
  log?.flatMap(history => history.note_attachments || []).map(attachment => ({ url: attachment, created_on: "", id: 0, pin_id: 0 })) ?? [];
